import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { Row, Col, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import PaymentTypesButtons from "../buttons/PaymentTypesButtons";
import DatePicker, { registerLocale } from "react-datepicker";
import pl from "date-fns/locale/pl";
registerLocale("pl", pl);

const RegisterPaymentForm = (props) => {
    const { t } = useTranslation();
    const { payment, setPayment, setFormChanged, blockForm } = props;

    return (
        <Row>
            <Col xs={6}>
                <Form.Group className="mb-3" controlId="paymentAmount">
                    <Form.Label className="w-100">
                        {t(`payments.paymentAmount`)} <span className="req">*</span>
                    </Form.Label>
                    <Form.Control
                        value={payment.payment_amount}
                        placeholder={t("payments.typePaymentAmount")}
                        onChange={(e) => {
                            setPayment({ ...payment, payment_amount: e.target.value });
                            setFormChanged(true);
                            $("#paymentAmount").removeClass("is-invalid");
                        }}
                        disabled={blockForm}
                    />
                </Form.Group>
            </Col>
            <Col xs={6}>
                <Form.Group className="mb-3">
                    <Form.Label>
                        {t("payments.paymentDate")} <span className="req">*</span>
                    </Form.Label>
                    <DatePicker
                        autoComplete="off"
                        selected={payment.payment_date}
                        onChange={(date) => {
                            setPayment({ ...payment, payment_date: date });
                            $("#paymentDate").removeClass("is-invalid");
                            setFormChanged(true);
                        }}
                        showIcon
                        locale="pl"
                        dateFormat="yyyy-MM-dd"
                        icon={<FontAwesomeIcon icon={faCalendar} />}
                        placeholderText={t("choose")}
                        id="paymentDate"
                        disabled={blockForm}
                    />
                </Form.Group>
            </Col>
            <Col xs={12}>
                <PaymentTypesButtons
                    blockForm={blockForm}
                    paymentMethod={payment.paymentMethod}
                    setPaymentMethod={(v) => setPayment({ ...payment, paymentMethod: v })}
                    setFormChanged={setFormChanged}
                    showAllTypes
                />
            </Col>
            <Col xs={12}>
                <Form.Group className="mb-3" controlId="paymentComment">
                    <Form.Label className="w-100">{t(`payments.paymentComment`)}</Form.Label>
                    <Form.Control
                        value={payment.payment_comment}
                        as="textarea"
                        placeholder={t("payments.paymentCommentPlaceholder")}
                        onChange={(e) => {
                            setPayment({ ...payment, payment_comment: e.target.value });
                            $("#paymentComment").removeClass("is-invalid");
                            setFormChanged(true);
                        }}
                        disabled={blockForm}
                    />
                </Form.Group>
            </Col>
        </Row>
    );
};

export default RegisterPaymentForm;
